'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import Box from '@classify/react-core-components/Box';
import { isAllowedUrl } from '@/modules/image';
type Props = {
  src: string;
};
const THUMBNAIL_SIZES = {
  default: 188,
  sm: 286,
  md: 250,
  lg: 388
};
export default function HeroImage(t0) {
  const $ = _c(5);
  const {
    src
  } = t0;
  let t1;
  if ($[0] !== src) {
    t1 = isAllowedUrl(src) ? <Image src={src} alt="" fill={true} style={{
      objectFit: "cover"
    }} /> : <img src={src} alt="" style={{
      position: "absolute",
      height: "100%",
      width: "100%",
      inset: "0px",
      objectFit: "cover",
      color: "transparent"
    }} />;
    $[0] = src;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const image = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      position: "relative",
      overflow: "hidden",
      borderRadius: "50%",
      width: {
        xs: THUMBNAIL_SIZES.default,
        sm: THUMBNAIL_SIZES.sm,
        md: THUMBNAIL_SIZES.md,
        lg: THUMBNAIL_SIZES.lg
      },
      height: {
        xs: THUMBNAIL_SIZES.default,
        sm: THUMBNAIL_SIZES.sm,
        md: THUMBNAIL_SIZES.md,
        lg: THUMBNAIL_SIZES.lg
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== image) {
    t3 = <Box sx={t2}>{image}</Box>;
    $[3] = image;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}